









































































import Vue from 'vue'
import Component from 'vue-class-component'
import { TwitterCardTypes, MetadataTranslation, TwitterCards } from '@/modules/seo/types'
import { Getter, Mutation } from 'vuex-class'
import FileSelectorField from '@/modules/media/components/FileSelectorField.vue'

@Component({
    components: { FileSelectorField },
})
export default class TwitterCardEditor extends Vue {

    @Getter('seo/metadata/current/translation')
    public translation: MetadataTranslation

    @Mutation('seo/metadata/current/translation/field/update')
    public updateTranslationField: (payload: {field: string, value: any}) => void

    public types = [
        {
            type: TwitterCardTypes.Summary,
            name: 'Tarjeta de resumen',
            icon: 'mdi-cards',
        },
        {
            type: TwitterCardTypes.SummaryLargeImage,
            name: 'Tarjeta de resumen con imagen grande',
            icon: 'mdi-account-card-details',
        },
        {
            type: TwitterCardTypes.Player,
            name: 'Tarjeta con reproductor multimedia',
            icon: 'mdi-folder-multiple-image',
        },
        {
            type: TwitterCardTypes.App,
            name: 'Tarjeta de app',
            icon: 'mdi-application',
        },
    ]

    get twitter (): TwitterCards {
        if (!this.translation) {
            return new TwitterCards()
        }

        return this.translation.twitter
    }

    get enabled (): boolean {
        return this.twitter.type !== TwitterCardTypes.None
    }

    public update (field: string, value: any) {
        this.updateTranslationField({ field: `twitter.${field}`, value })
    }
}
